import { db } from '../firebase';
import firebase from 'firebase/app';
import { createGalleryImage } from './galleryService';

const COLLECTION = 'web_notifications';

export async function getWebNotifications({ search = '', category = 'all' } = {}) {
  try {
    let snapshot;
    try {
      snapshot = await db.collection(COLLECTION).orderBy('createdAt', 'desc').get();
    } catch (e) {
      snapshot = await db.collection(COLLECTION).get();
    }

    let list = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt ? (data.createdAt.toDate ? data.createdAt.toDate() : new Date(data.createdAt)) : new Date(),
        updatedAt: data.updatedAt ? (data.updatedAt.toDate ? data.updatedAt.toDate() : new Date(data.updatedAt)) : null,
      };
    });

    if (category && category !== 'all') {
      list = list.filter((n) => n.category === category);
    }

    if (search && search.trim()) {
      const q = search.trim().toLowerCase();
      list = list.filter((n) => {
        const title = (n.title || '').toLowerCase();
        const summary = (n.summary || '').toLowerCase();
        const content = (n.content || '').toLowerCase();
        return title.includes(q) || summary.includes(q) || content.includes(q);
      });
    }

    return list;
  } catch (error) {
    console.error('Error fetching web notifications:', error);
    return [];
  }
}

export async function getWebNotificationById(id) {
  const doc = await db.collection(COLLECTION).doc(id).get();
  if (!doc.exists) return null;
  const data = doc.data();
  return {
    id: doc.id,
    ...data,
    createdAt: data.createdAt ? (data.createdAt.toDate ? data.createdAt.toDate() : new Date(data.createdAt)) : new Date(),
  };
}

export async function createWebNotification(data) {
  const payload = {
    title: data.title || '',
    summary: data.summary || data.body || '',
    content: data.content || '',
    category: data.category || 'Announcement',
    imageUrl: data.imageUrl || null,
    actionUrl: data.actionUrl || null,
    buttonText: data.buttonText || null,
    isPinned: Boolean(data.isPinned),
    isActive: data.isActive !== undefined ? Boolean(data.isActive) : true,
    sourcePushNotificationId: data.sourcePushNotificationId || null,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  };

  const docRef = await db.collection(COLLECTION).add(payload);

  // Auto-save image to Image Gallery (gallery_images) if provided
  if (data.imageUrl && data.saveToGallery !== false) {
    try {
      await createGalleryImage({
        title: data.title || 'Web Notification Banner',
        category: data.category || 'General',
        description: data.summary || data.content || '',
        imageUrl: data.imageUrl,
      });
    } catch (galleryErr) {
      console.warn('Auto-save web notification image to gallery notice:', galleryErr);
    }
  }

  return docRef.id;
}

export async function updateWebNotification(id, data) {
  const payload = {
    title: data.title,
    summary: data.summary || data.body || '',
    content: data.content || '',
    category: data.category || 'Announcement',
    imageUrl: data.imageUrl || null,
    actionUrl: data.actionUrl || null,
    buttonText: data.buttonText || null,
    isPinned: Boolean(data.isPinned),
    isActive: data.isActive !== undefined ? Boolean(data.isActive) : true,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  };

  await db.collection(COLLECTION).doc(id).update(payload);
}

export async function deleteWebNotification(id) {
  await db.collection(COLLECTION).doc(id).delete();
}
